import React, { Fragment } from 'react'
import { Field } from 'formik'
import {
  Container,
  Label,
  CheckboxLabel,
  CheckboxContainer,
  ArchetypeContainer,
} from './AccountDetailsCheckboxInput.styles'
import RegisteredTrademarkIcon from 'components/RegisteredTrademarkIcon'

const AccountDetailsCheckboxInput = props => {
  const {
    archetypesData,
    ErrorContainer,
    errors,
    label,
    name,
    values,
    setFieldValue,
  } = props

  const insertTrademark = phrase => {
    const phraseParts = phrase.split('Step')

    return phraseParts.length === 1 ? (
      phraseParts[0]
    ) : (
      <Fragment>
        {phraseParts.map((part, index) => {
          const isNotLast = index !== phraseParts.length - 1
          return (
            <Fragment key={index}>
              {part}
              {isNotLast && (
                <Fragment>
                  Step
                  <RegisteredTrademarkIcon />
                </Fragment>
              )}
            </Fragment>
          )
        })}
      </Fragment>
    )
  }

  return (
    <Container>
      <Label>
        {label}
        {errors && <ErrorContainer>{errors}</ErrorContainer>}
      </Label>
      <ArchetypeContainer role="group">
        {archetypesData &&
          archetypesData.map(archetype => (
            <CheckboxContainer key={archetype.id}>
              <Field
                checked={values.includes(archetype.id)}
                name={name}
                onChange={() => {
                  if (!values.includes(archetype.id)) {
                    const newArchetypesArr = [...values, archetype.id]
                    setFieldValue('archetypes', newArchetypesArr.sort())
                  } else {
                    const index = values.indexOf(archetype.id)
                    setFieldValue('archetypes', [
                      ...values.slice(0, index),
                      ...values.slice(index + 1),
                    ])
                  }
                }}
                type="checkbox"
                value={archetype.id}
              />
              <CheckboxLabel>
                {insertTrademark(archetype.description)}
              </CheckboxLabel>
            </CheckboxContainer>
          ))}
      </ArchetypeContainer>
    </Container>
  )
}

export default AccountDetailsCheckboxInput



// WEBPACK FOOTER //
// ./src/components/AccountDetailsCheckboxInput/AccountDetailsCheckboxInput.js